var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCabinCrewDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1B2646;}\n\t.st1{fill:#1B2646;}\n\t.st2{fill:none;stroke:#1B2646;stroke-width:0.9444;}\n\t.st3{fill:none;stroke:#1B2646;stroke-width:0.7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.8,15l2.1,1.3l4,0.6c0.7,0.1,1.1,0.6,1.3,0.9l1.3,2.8c0.1,0.6-0.4,0.8-0.7,0.8H2.9c-1,0.1-1.1-0.5-1-0.8 L3,18.2c0.1-0.3,0.3-0.5,0.5-0.7c0.4-0.4,1.1-0.6,1.7-0.7l3.6-0.6l2.1-0.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.9,4.6l1.6-3.5C8.6,1,8.9,0.6,9.6,0.8l2.1,0.9l2.1-0.9c0.2-0.1,0.7-0.1,1,0.3c0,0,0,0,0,0.1l1.6,3.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.9,4.6l1.6-3.5C8.6,1,8.9,0.6,9.6,0.8l2.1,0.9l2.1-0.9c0.2-0.1,0.7-0.1,1,0.3c0,0,0,0,0,0.1l1.6,3.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.8,14.1l-0.6-7.6c0-1.9-1.5-2.5-2.2-2.6c-0.6,0-5,0-6.3,0C8.5,3.9,8.3,4,8.1,4c-1.7,0.5-2,1.9-1.9,2.5 c0.1,1.8-0.2,5.8-0.4,7.6c0,0.9,1.7,1.6,4.5,1.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.8,14.1c0,0.9-1.8,1.6-4.5,1.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.7,10.4c-0.2,1.2-0.8,2.5-1.5,3.5c-0.7,1-1.6,1.6-2.4,1.6c-0.4,0-0.8-0.2-1.3-0.5c-0.4-0.3-0.9-0.7-1.3-1.3 c-0.8-1.1-1.3-2.4-1.4-3.5C7.8,8.6,8.1,7.9,8.7,7.5C9,7.2,9.4,7.1,9.9,7c0.5-0.1,1.1-0.1,1.9-0.1c1.6,0,2.7,0.2,3.3,0.7 C15.6,8.1,15.9,8.9,15.7,10.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.6,16.2l-2.5,4.6c-0.1,0.3-0.5,0.3-0.7,0L9,16.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.3,16.5c-0.2,0.3-0.8,0.7-1.9,0.7l-0.5,1.4l1.8,0.3l1,2.1h1.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.3,16.5c-0.2,0.3-0.8,0.7-1.9,0.7l-0.5,1.4l1.8,0.3l1,2.1h1.7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.3,16.5c0.2,0.3,0.8,0.7,1.9,0.7l0.5,1.4l-1.8,0.3l-1,2.1h-1.7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.3,16.5c0.2,0.3,0.8,0.7,1.9,0.7l0.5,1.4l-1.8,0.3l-1,2.1h-1.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinCrewDark);
export default __webpack_public_path__ + "static/media/cabin-crew-dark.ff46e01381285dd2a1051aa77f14efbb.svg";
export { ForwardRef as ReactComponent };